import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Roles } from '@enums/roles.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DatasecurityComponent } from '../../authentication/datasecurity/datasecurity.component';
import { AboutUsDialogComponent } from '../about-us/about-us-dialog.component';
import { ReleaseNotesDialogComponent } from '../../dialog/release-notes-dialog/release-notes-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends ComponentBase implements OnInit {

  public className = 'FooterComponent';

  isNavbarCollapsed = true;

  public isUserAuthenticated: boolean;
  public isVisible: boolean = false;

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(
    private usersService: UsersService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private dialog: NgbModal,
    injector: Injector) {
      super(injector);
      this.subscribeToUserAuthState();

      this.router.events.forEach((event) => {
        if (event instanceof NavigationEnd) {
          if (event['url'].startsWith('/auth/login')
            || event['url'].startsWith('/auth/register')
            || event['url'].startsWith('/auth/forgotpassword')
            || event['url'].startsWith('/auth/resetpassword')
            || event['url'].startsWith('/auth/used-token-feedback')
            || event['url'].startsWith('/logout-callback')
            || event['url'].startsWith('/forbidden')
            || event['url'].startsWith('/public-charge-plans')
            || event['url'].startsWith('/public-charge')
            || event['url'].startsWith('/public-charge-canceled')
            || event['url'].startsWith('/auth/emailconfirmation')
            || event['url'].startsWith('/auth/emailChangeConfirmation')
            || event['url'].startsWith('/auth/welcome')) {
            this.isVisible = false;
          } else {
            this.isVisible = true;
          }
        }
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToUserAuthState();
  }

  subscribeToUserAuthState() {
    this.authenticationService.authChanged$.subscribe(result => {
      super.ngOnInit();
      this.isUserAuthenticated = result;
    })
  }

  isRoleCustomer(): boolean {
    return this.authenticationService.userHasRole(Roles.Customer);
  }

  openDSDialog() {
    const dialogRef = this.dialog.open(DatasecurityComponent, { centered: true, size: 'xl', backdrop: 'static' });

    dialogRef.result.then((result) => {
      this.ngOnInit();
    }, (backdrop) => {

    });
  }

  openAboutUsDialog() {
    const dialogRef = this.dialog.open(AboutUsDialogComponent, { centered: true, size: 'lg', backdrop: 'static' });

    dialogRef.result.then((result) => {
      this.ngOnInit();
    }, (backdrop) => {

    });
  }

  openReleaseNotesDialog() {
    const dialogRef = this.dialog.open(ReleaseNotesDialogComponent, { centered: true, size: 'xl', backdrop: 'static' });

    dialogRef.result.then((result) => {
      this.ngOnInit();
    }, (backdrop) => {

    });
  }
}
